import { View, Text, XStack, YStack } from "tamagui";
import { RiArrowRightSLine, RiBankCardLine, RiShieldCheckLine, RiInformationLine } from "react-icons/ri";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import RadiusCard from "@components/layout/RadiusCard";
import { colors } from "@styles/colors";
import { Header, Fade, detectCard, RADIUS } from "./Common";
import { TapPaySecurityNote } from "@components/payment/TapPayCompliance";

export default function CardList({
  cards,
  onAdd,
  onBack,
  onCardPress,
}: {
  cards: any[];
  onAdd: () => void;
  onBack: () => void;
  /** 選填：點擊單張卡片時觸發（用於進入付款方式詳細頁）。未傳則維持原本不可點行為。 */
  onCardPress?: (card: any) => void;
}) {
  return (
    <RadiusContentWrapper padding="0" space={0}>
      <Header title="付款方式" sub="管理你綁定的信用卡" onBack={onBack} />

      <YStack p="$4" gap="$3">
        {/* Card list */}
        {cards.length > 0 && (
          <Fade i={0}>
            <Text fontSize={12} fontWeight="600" color={colors.gray} mb="$2" pl="$1">
              已綁定 ({cards.length})
            </Text>
            <YStack bg={colors.light} br={RADIUS} ov="hidden" mb="$4">
              {cards.map((card, i) => {
                const ct = detectCard(card.digits || "4");
                return (
                  <XStack
                    key={card.id}
                    p="$3.5"
                    bbw={i === cards.length - 1 ? 0 : 1}
                    bbc={colors.bgGray1}
                    ai="center"
                    gap="$3"
                    cursor="pointer"
                    onPress={() => onCardPress?.(card)}>
                    {/* Card visual chip */}
                    <View
                      w={52}
                      h={34}
                      br={8}
                      background={ct ? `linear-gradient(135deg, ${ct.color}, ${ct.color}CC)` : "linear-gradient(135deg,#1E3A5F,#2563EB)"}
                      ai="center"
                      jc="center"
                    >
                      <Text fontSize={11} fontWeight="800" color="#fff" ls={0.5}>
                        {ct?.name || "CARD"}
                      </Text>
                    </View>
                    <YStack f={1} miw={0}>
                      <XStack ai="center" gap="$2" mb="$1">
                        <Text fontSize={14} fontWeight="700">
                          **** **** **** {card.last4}
                        </Text>
                      </XStack>
                      <Text fontSize={11} color={colors.gray200}>
                        {card.holder} · 到期 {card.expiry}
                      </Text>
                    </YStack>
                    <RiArrowRightSLine color={colors.gray200} size={20} />
                  </XStack>
                );
              })}
            </YStack>
          </Fade>
        )}

        {/* Add card CTA */}
        <Fade i={1}>
          <YStack mt="$5">
            <Text fontSize={12} fontWeight="600" color={colors.gray} mb="$3" pl="$1">
              新增付款方式
            </Text>
            <YStack onPress={onAdd} cursor="pointer" pressStyle={{ opacity: 0.85 }}>
              <RadiusCard>
                <XStack ai="center" gap="$3.5">
                  <View w={46} h={46} br={12} bg={colors.primaryActive} ai="center" jc="center">
                    <RiBankCardLine size={24} color={colors.primary} />
                  </View>
                  <YStack f={1}>
                    <XStack ai="center" gap="$1.5" mb="$1">
                      <Text fontSize={14} fontWeight="700" color={colors.grayDark}>
                        新增信用卡
                      </Text>
                      <XStack ai="center" gap="$1" bg={`${colors.green}15`} bw={1} bc={`${colors.green}30`} br={8} px="$2" py="$1">
                        <RiShieldCheckLine size={10} color={colors.green} />
                        <Text fontSize={9} fontWeight="800" color={colors.green} ls={0.3}>
                          TapPay
                        </Text>
                      </XStack>
                    </XStack>
                    <Text fontSize={11} color={colors.gray200}>
                      PCI DSS L1 · Visa / Mastercard / JCB
                    </Text>
                  </YStack>
                  <RiArrowRightSLine color={colors.primary} size={20} />
                </XStack>
              </RadiusCard>
            </YStack>
          </YStack>
        </Fade>

        {/* TapPay 金流安全揭露（審核要求：付款方式頁需說明金流商與加密／PCI 認證） */}
        <Fade i={2}>
          <TapPaySecurityNote />
        </Fade>

        {/* Security note */}
        <Fade i={3}>
          <YStack bg={colors.primaryActive} br={RADIUS} p="$4">
            <XStack ai="center" gap="$2" mb="$3">
              <RiInformationLine color={colors.primary} size={22} />
              <Text fontSize={12} fontWeight="700" color={colors.primary}>
                付款方式儲存在你的帳號,可在各瓦斯帳戶選擇要啟用哪幾種。某些瓦斯行可能不接受特定支付工具。
              </Text>
            </XStack>
          </YStack>
        </Fade>
      </YStack>
    </RadiusContentWrapper>
  );
}
